<template>
  <MapAssociations></MapAssociations>
</template>

<script>
import MapAssociations from '@/components/MapAssociations.vue'

export default {
  name: 'MapView',
  components: {
    MapAssociations
  }
}
</script>
